import { Textarea } from "@/components/ui/textarea";
import type { AutomationStep } from "@/types/Automation";
import type { StepNodeData } from "../types";
import { useDebouncedSyncedString } from "../useDebouncedSyncedString";

export function InstagramDmBodyTextarea({
  step,
  onStepDataChange,
}: {
  step: AutomationStep;
  onStepDataChange: StepNodeData["onStepDataChange"];
}) {
  const { draft, onChange, onBlur, onFocus } = useDebouncedSyncedString({
    syncKey: step.id,
    externalValue: step.data?.body || "",
    onCommit: ({ value }) => onStepDataChange({ stepId: step.id, field: "body", value }),
  });

  return (
    <Textarea
      placeholder="Enter Instagram DM message..."
      value={draft}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      className="min-h-20 text-sm"
      data-testid="automation-instagram-dm-body"
    />
  );
}
